import { WebApi } from '../../services/WebApi'

const state = () => ({
  loadedClientOnboardingInvite: false,
  loadingClientOnboardingInvite: false,
  clientOnboardingInvite: null
})

const mutations = {
  setClientOnboardingInvite (state, value) {
    state.clientOnboardingInvite = value
    state.loadedClientOnboardingInvite = true
  },
  setLoading (state, value) {
    state.loadingClientOnboardingInvite = !!value
  },
  setClientDetailsUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.clientDetailsUpdated = true
    }
  },
  setClientAddressUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.clientAddressUpdated = true
    }
  },
  setClientNoteUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.clientNoteUpdated = true
    }
  },
  setPetDetailsUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.petDetailsUpdated = true
    }
  },
  setPetNoteUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.petNoteUpdated = true
    }
  },
  setVetContactUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.vetContactUpdated = true
    }
  },
  setAlternateContactUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.alternateContactUpdated = true
    }
  },
  setAcceptMarketingUpdated (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.acceptMarketingUpdated = true
    }
  },
  setContractCompleted (state) {
    if (state.clientOnboardingInvite) {
      state.clientOnboardingInvite.contractCompleted = true
    }
  },
  setUpdatedPet (state, petId) {
    if (state.clientOnboardingInvite) {
      if (!state.clientOnboardingInvite.updatedPets.includes(petId)) {
        state.clientOnboardingInvite.updatedPets.push(petId)
      }
    }
  },
  setUpdatedPetNote (state, petId) {
    if (state.clientOnboardingInvite) {
      if (!state.clientOnboardingInvite.updatedPetNotes.includes(petId)) {
        state.clientOnboardingInvite.updatedPetNotes.push(petId)
      }
    }
  }
}

const actions = {
  fetchClientOnboardingInvite ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.get('ClientOnboardingInvite/' + inviteId)
        .then(response => {
          commit('setClientOnboardingInvite', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
        .finally(() => commit('setLoading', false))
    })
  },
  viewClientOnboardingInvite ({ commit }, inviteId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', true)
      WebApi.put('ClientOnboardingInvite/' + inviteId + '/View')
        .then(response => {
          commit('setClientOnboardingInvite', response.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
        .finally(() => commit('setLoading', false))
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
